<template>
  <div
    class="chat-bubble"
    :class="{
      'dark-theme': isTextColourLight,
      'show': hasUserTyping,
    }"
  >
    <div class="typing">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    {{ $t('Participants are typing') }}
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Socket from '@/socket'

export default {
  data() {
    return {
      usersTyping: {},
      hasUserTyping: false,
      clearUserTypingTimeout: null,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },
  },
  watch: {
    '$store.state.slideActive.id': function handleSlideChange() {
      this.hasUserTyping = false
    },
  },
  mounted() {
    Socket.getSocket().on('user-is-typing', this.handleSocketUserIsTyping)
  },
  destroyed() {
    Socket.getSocket().off('user-is-typing', this.handleSocketUserIsTyping)
  },
  methods: {
    handleSocketUserIsTyping(socketData) {
      const [socketId, isTyping] = socketData

      if (!isTyping) {
        delete this.usersTyping[`${socketId}`]
      } else {
        this.usersTyping[`${socketId}`] = true
      }

      if (this.clearUserTypingTimeout) {
        clearTimeout(this.clearUserTypingTimeout)
        this.clearUserTypingTimeout = null
      }

      // eslint-disable-next-line func-names
      this.$nextTick(function () {
        this.hasUserTyping = Object.values(this.usersTyping).some((item) => item)
        this.clearUserTypingTimeout = setTimeout(() => {
          this.usersTyping = {}
          this.hasUserTyping = false
        }, 3500)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-bubble {
  opacity: 0;
  background: rgba(255, 255, 255, 0.9);
  pointer-events: none;
  border-radius: 27px;
  padding: 8px 18px;
  display: flex;
  width: max-content;
  transition: opacity 0.2s ease-in;
  .typing {
    margin-right: 0.5rem;
    .dot {
      background-color: rgba(0,0,0,0.7);
      border-radius: 50%;
      height: 7px;
      width: 7px;
      margin-right: 4px;
      display: inline-block;
      animation: typingAnimation 0.8s infinite;
      &:nth-child(1) {
        animation-delay: 50ms;
      }
      &:nth-child(2) {
        animation-delay: 130ms;
      }
      &:nth-child(3) {
        animation-delay: 260ms;
      }
    }
  }
  &.show {
    opacity: 1;
  }
  &.dark-theme {
    background: rgba(0, 0, 0, 0.9);
    .dot {
      background-color: rgba(255,255,255,0.7);
      animation: typingAnimationDarkTheme 0.8s infinite;
    }
  }
}
@keyframes typingAnimation {
  0% {
    transform: translateY(0px);
    background-color:rgba(0,0,0,0.7);
  }
  30% {
    transform: translateY(-5px);
    background-color:rgba(0,0,0,0.4);
  }
  60% {
    transform: translateY(0px);
    background-color: rgba(0,0,0,0.2);
  }
}
@keyframes typingAnimationDarkTheme {
  0% {
    transform: translateY(0px);
    background-color:rgba(255,255,255,0.7);
  }
  30% {
    transform: translateY(-5px);
    background-color:rgba(255,255,255,0.4);
  }
  60% {
    transform: translateY(0px);
    background-color: rgba(255,255,255,0.2);
  }
}
</style>
